document.addEventListener("DOMContentLoaded", function () {
  // Cache DOM elements
  const modal = document.getElementById("reviewModal");
  const modalClose = document.getElementById("modalClose");
  const modalRating = document.getElementById("modalRating");
  const modalUserInfo = document.getElementById("modalUserInfo");
  const modalContent = document.getElementById("modalContent");
  const modalImages = document.getElementById("modalImages");

  // Early return if essential elements are missing
  if (!modal || !modalRating || !modalUserInfo || !modalContent || !modalImages) {
    return;
  }

  // Constants
  const STAR_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 22 21" fill="none">
    <path d="M10.1288 0.545575C10.5114 -0.13307 11.4886 -0.13307 11.8712 0.545574L14.5841 5.35886C14.7268 5.61204 14.9726 5.79061 15.2575 5.84809L20.6735 6.94089C21.4372 7.09497 21.7392 8.02441 21.2119 8.59792L17.4726 12.6655C17.2759 12.8794 17.182 13.1684 17.2154 13.4571L17.8497 18.9458C17.9392 19.7196 17.1485 20.2941 16.4402 19.9699L11.4162 17.6705C11.1519 17.5495 10.8481 17.5495 10.5838 17.6705L5.55982 19.9699C4.85146 20.2941 4.06083 19.7196 4.15027 18.9458L4.78461 13.4571C4.81797 13.1684 4.72409 12.8794 4.52741 12.6655L0.788051 8.59792C0.260824 8.02441 0.562819 7.09497 1.32645 6.94089L6.74251 5.84809C7.0274 5.79061 7.27318 5.61204 7.41588 5.35886L10.1288 0.545575Z" fill="#FA590E" />
  </svg>`;

  // Utility function to escape HTML
  /**
   * @param {string} text
   * @returns {string}
   */
  function escapeHtml(text) {
    if (typeof text !== "string") return "";
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }

  // Generate user info template
  /**
   * @param {string} customer
   * @returns {string}
   */
  function getUserInfoTemplate(customer) {
    const escapedCustomer = escapeHtml(customer || "");
    return `
      <div class="modal-user-details">
        <div class="modal-user-name-row">
          <span class="modal-user-name">${escapedCustomer}</span>
          <span class="modal-verified-badge">Verified</span>
        </div>
      </div>
    `;
  }

  // Generate star HTML
  /**
   * @param {string|number} rating
   * @returns {string}
   */
  function generateStars(rating) {
    const normalizedRating = Math.max(0, Math.min(5, parseInt(String(rating), 10) || 0));
    const stars = Array.from({ length: 5 }, function (_, i) {
      const isFilled = i < normalizedRating;
      return `<span class="star ${isFilled ? "filled" : "empty"}">${STAR_SVG}</span>`;
    }).join("");
    return `<div class="stars">${stars}</div>`;
  }

  // Generate user info HTML
  /**
   * @param {string} customer
   * @param {string} avatar
   * @returns {string}
   */
  function generateUserInfo(customer, avatar) {
    const escapedCustomer = escapeHtml(customer || "");
    const initial = escapedCustomer.charAt(0).toUpperCase();
    const userInfoTemplate = getUserInfoTemplate(customer);

    if (avatar) {
      return `<img loading="lazy" src="${escapeHtml(avatar)}" alt="${escapedCustomer}" class="modal-avatar">${userInfoTemplate}`;
    }

    return `
      <div class="modal-avatar" style="background: #FA590E; display: flex; align-items: center; justify-content: center; color: #fff; font-weight: 600; font-size: 18px;">
        ${initial}
      </div>
      ${userInfoTemplate}
    `;
  }

  // Generate images HTML
  /**
   * @param {string} previewImg
   * @returns {string}
   */
  function generateImages(previewImg) {
    return previewImg ? `<img loading="lazy" src="${escapeHtml(previewImg)}" alt="Review image" class="modal-image">` : "";
  }

  // Open modal
  /**
   * @param {{reviewContent?: string, customer?: string, rating?: string, avatar?: string, previewImg?: string}} reviewData
   */
  function openModal(reviewData) {
    const reviewContent = reviewData.reviewContent || "";
    const customer = reviewData.customer || "";
    const rating = reviewData.rating || "0";
    const avatar = reviewData.avatar || "";
    const previewImg = reviewData.previewImg || "";

    if (modalRating) modalRating.innerHTML = generateStars(rating);
    if (modalUserInfo) modalUserInfo.innerHTML = generateUserInfo(customer, avatar);
    if (modalContent) modalContent.textContent = reviewContent;
    if (modalImages) modalImages.innerHTML = generateImages(previewImg);

    if (modal) {
      modal.classList.add("active");
      document.body.style.overflow = "hidden";
    }
  }

  // Close modal
  function closeModal() {
    if (modal) {
      modal.classList.remove("active");
      document.body.style.overflow = "";
    }
  }

  // Handle review item click using event delegation
  document.addEventListener("click", function (e) {
    if (!e.target) return;
    /** @type {HTMLElement} */
    const target = /** @type {HTMLElement} */ (e.target);
    if (typeof target.closest !== "function") return;
    
    const reviewItem = /** @type {HTMLElement|null} */ (target.closest(".review-item"));
    if (!reviewItem) return;

    const reviewData = {
      reviewContent: reviewItem.dataset.reviewContent || "",
      customer: reviewItem.dataset.customer || "",
      rating: reviewItem.dataset.rating || "0",
      avatar: reviewItem.dataset.avatar || "",
      previewImg: reviewItem.dataset.previewImg || ""
    };

    openModal(reviewData);
  });

  // Close modal handlers
  if (modalClose) {
    modalClose.addEventListener("click", closeModal);
  }

  if (modal) {
    modal.addEventListener("click", function (e) {
      if (e.target === modal) {
        closeModal();
      }
    });
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.classList.contains("active")) {
      closeModal();
    }
  });
});
